export const categories = [
  {
    slug: 'wanghong-baoliao',
    name: '网红爆料',
    description: '最新网红八卦、直播圈内幕、大V争议事件追踪',
    icon: 'ri-user-star-line',
    colorClass: 'bg-primary-100',
    imageSeq: 'category-01',
  },
  {
    slug: 'yule-quan',
    name: '娱乐圈',
    description: '明星动态、影视资讯、综艺热点第一时间速递',
    icon: 'ri-movie-2-line',
    colorClass: 'bg-secondary-100',
    imageSeq: 'category-02',
  },
  {
    slug: 'chigua-qianxian',
    name: '吃瓜前线',
    description: '热点事件深度追踪、争议话题全方位解读',
    icon: 'ri-fire-line',
    colorClass: 'bg-accent-100',
    imageSeq: 'category-03',
  },
  {
    slug: 'pp-liao',
    name: 'PP料专区',
    description: 'PP料今日最新价格行情、市场分析与交易动态',
    icon: 'ri-funds-line',
    colorClass: 'bg-background-200',
    imageSeq: 'category-04',
  },
  {
    slug: 'heiliaojiemi',
    name: '黑料揭秘',
    description: '深度揭秘行业内幕、独家调查报道与真相追踪',
    icon: 'ri-spy-line',
    colorClass: 'bg-primary-100',
    imageSeq: 'category-05',
  },
  {
    slug: 'redian-jujiao',
    name: '热点聚焦',
    description: '社会热点、争议话题、全民讨论的焦点事件汇总',
    icon: 'ri-radar-line',
    colorClass: 'bg-accent-100',
    imageSeq: 'category-06',
  },
];

export const hotTags = [
  '顶流塌房', '带货翻车', '恋情曝光', '维权风波', '直播争议',
  '综艺名场面', '热搜第一', '品牌解约', '深夜回应', '律师函警告',
];

export const topSearches = [
  { keyword: '某顶流深夜发文回应', heat: 9856321 },
  { keyword: '网红直播间争议言论', heat: 8754120 },
  { keyword: '知名演员新剧路透曝光', heat: 7652300 },
  { keyword: 'PP料今日最新价格走势', heat: 6541890 },
  { keyword: '某女星工作室发布声明', heat: 5987456 },
  { keyword: '综艺节目录制现场事故', heat: 5210360 },
  { keyword: '知名品牌代言人更换', heat: 4876500 },
  { keyword: '吃瓜群众今日热议话题', heat: 4321890 },
];